import AbandonedSignUpApi from "../api/AbandonedSignUpApi";
import {ref} from "vue";

export const ABANDONED_SIGN_UP_MODEL_COMPANY = "company";
export const ABANDONED_SIGN_UP_MODEL_USER = "user";


export const useAbandonedSignUp = (model = ABANDONED_SIGN_UP_MODEL_USER, useStore, config = null) => {

  const abandonedSignUpUuid = ref("");


  const updateAbandonedSignUp = async () => {
    if (config && config?.shouldContinueReporting && !await config.shouldContinueReporting()) return;
    if (window.location.href.includes("laravel.test")) return;

    const api = new AbandonedSignUpApi(model);

    const store = useStore();

    let data, firstLocation;
    let preflightPassed = true;

    const urlParams = new URLSearchParams(window.location.search);

    switch (model) {
    case ABANDONED_SIGN_UP_MODEL_USER:
      data = {
        model: ABANDONED_SIGN_UP_MODEL_USER,
        name: `${store.newUserDetails.firstName || ""} ${store.newUserDetails.lastName || ""}`,
        phone: (store.newUserDetails.phone || "") + "",
        acquisition_source: localStorage.getItem("acquisition_source") || "",
        email: store.newUserDetails.email,
        opportunity_uuid: store.applicationForm.uuid,
        furthest_step: store.furthestStep.name,
        furthest_step_at: store.furthestStep.at,
        total_steps: store.furthestStep.totalSteps,
        completed_steps: store.furthestStep.completedSteps,
        meta: {
          first_name: store.newUserDetails.firstName,
          last_name: store.newUserDetails.lastName,
          city: store.newUserDetails.city,
          state: store.newUserDetails.state,
          lat: store.newUserDetails.lat,
          lng: store.newUserDetails.lng,
          resume: {
            uuid: config?.parseResumeStore?.localResume?.uuid,
            name: config?.parseResumeStore?.localResume?.name,
            formatted_size: config?.parseResumeStore?.localResume?.formattedSize,
          },
        }
      };
      break;
    case ABANDONED_SIGN_UP_MODEL_COMPANY:
      firstLocation = store.locations.find(location => location.city && location.state);
      if (!firstLocation) firstLocation = store.locations[0];

      data = {
        name: store.name || "",
        phone: store.phone ? (store.phone + "") : "",
        acquisition_source: localStorage.getItem("acquisition_source") || "",
        email: store.email || "",
        model: ABANDONED_SIGN_UP_MODEL_COMPANY,
        meta: {
          first_name: store.firstName || "",
          last_name: store.lastName || "",
          website: store.website || "",
          city: firstLocation.city || "",
          state: firstLocation.state || "",
          billing_plan_id: store.billingPlanId,
          cycle_interval: store.cycleInterval,
          plan_selected: urlParams.get("plan") || "",
        },
        furthest_step: store.furthestStep,
        furthest_step_at: store.furthestStepAt,
        total_steps: store.totalSteps,
        completed_steps: store.completedSteps,
      };
      break;
    }

    if (!data?.name?.trim() || !preflightPassed) return;
    if (abandonedSignUpUuid.value) data.uuid = abandonedSignUpUuid.value;

    try {
      const response = await api.create(data);
      if (response?.data?.uuid) abandonedSignUpUuid.value = response.data.uuid;
    } catch (e) {
      // Do nothing
      console.error(e);
    }
  };

  const startInterval = () => setInterval(() => updateAbandonedSignUp(), 5 * 1000);

  let abandonedInterval;

  const manuallyTrigger = async () => {
    clearInterval(abandonedInterval);
    abandonedInterval = startInterval();
    await updateAbandonedSignUp();
  };

  const manuallyStart = () => {
    abandonedInterval = startInterval();
    window.addEventListener("beforeunload", manuallyTrigger);
    window.addEventListener("visibilitychange", manuallyTrigger);
  };

  const manuallyCancel = () => {
    window.removeEventListener("beforeunload", manuallyTrigger);
    window.removeEventListener("visibilitychange", manuallyTrigger);
    clearInterval(abandonedInterval);
  };

  manuallyStart();

  return {
    manuallyTrigger,
    manuallyStart,
    manuallyCancel,
  };
};
